<div class="multi-video-list"></div>
<button class="button add-video-item"><i class="icon-plus"></i>
  {{#if isAudio}}
  {{t "editor.inspector.properties.video.addAudio"}}
  {{else}}
  {{t "editor.inspector.properties.video.addLanguage"}}
  {{/if}}
</button>